import {Directive, HostListener, inject} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[noLeadingSpaces]'
})
export class NoLeadingSpacesDirective {

  ngControl = inject(NgControl);
  @HostListener('input', ['$event'])
  onInputChange( event: Event ) {
    const inputElement = event.target as HTMLInputElement;
    const newValue = inputElement.value.replace(/^\s+/, '').replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ\s]/g, '');

    if (newValue !== inputElement.value) {
      this.ngControl.control?.setValue(newValue);
    }
  }
}
